import React from 'react';
import { Link } from 'react-router-dom';

function Ticker({ message, link, onClose }) {
  return (
    <div className="ticker-container">
      <div className="ticker-content">
        <span className="ticker-icon">📌</span>
        {link ? (
          <Link to={link} className="ticker-link">
            {message}
          </Link>
        ) : (
          <span>{message}</span>
        )}
      </div>
      {onClose && (
        <button className="ticker-close" onClick={onClose} aria-label="Close">
          ✕
        </button>
      )}
    </div>
  );
}

export default Ticker;
